import { StoreState } from '../store-interfaces';
import { createSelector } from 'reselect';
import { combinedFeatureFlagsSelector } from './featureFlagsSelectors';

export const selectGoogleClientCredentials = (state: StoreState) =>
  state.googleAds?.credentials?.googleClientCredentials || [];

export const selectGoogleAdAudiences = (state: StoreState) =>
  (state.googleAds.entities || []).filter(
    aud => aud?.subtype.toLowerCase() === 'googleads',
  );

export const selectGoogleAdAudience = (state: StoreState, id) =>
  (state.googleAds?.entities || []).find(v => v.id === id);
